export default "__VITE_ASSET__1a6965c7__"